import { render, staticRenderFns } from "./typesetting5.vue?vue&type=template&id=4ebe8849&scoped=true&"
import script from "./typesetting5.vue?vue&type=script&lang=js&"
export * from "./typesetting5.vue?vue&type=script&lang=js&"
import style0 from "./typesetting5.vue?vue&type=style&index=0&id=4ebe8849&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe8849",
  null
  
)

export default component.exports